import { useMutation, useQueryClient } from '@tanstack/react-query';
import { notificationController } from 'infrastructure/antd/controllers/notification-controller';
import { useTranslation } from 'react-i18next';
import dataService from 'services/dataService';
import { apiCreateTask } from 'services/dataService/resources/oneplatform/api';

import { getTasksByPatientQueryKey } from './use-get-tasks-by-patient';

import type { ICreateTaskPayload, ITaskCard } from '../types';

export const useCreateTask = (patientGuid: string) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: (payload: Omit<ICreateTaskPayload, 'patientGuid'>) =>
      dataService.createOne<{ task: ITaskCard }>(apiCreateTask(), {
        ...payload,
        patientGuid,
      }),
    onSuccess: () => {
      notificationController.success({
        message: t('tasksDrawer.createSuccess'),
      });
      queryClient.invalidateQueries(getTasksByPatientQueryKey(patientGuid));
    },
    onError: () => {
      notificationController.error({
        message: t('tasksDrawer.createError'),
      });
    },
  });
};
